import { useQuery } from 'react-query';

import { PowerlistData, fetchPowerlistData } from '../utils/backend-api/powerlist';

export const POWERLIST_KEY = 'POWERLIST';

export default function usePowerlist(powerlistType: 'crypto' | 'enterprise') {
  const { data, isLoading: isLoadingPowerlist } = useQuery<PowerlistData>(
    POWERLIST_KEY,
    async () => await fetchPowerlistData(powerlistType)
  );
  return { data, isLoadingPowerlist };
}
